var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.6668 42.6667L32.0002 32L21.3335 42.6667",
    stroke: "#48525B",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 32V56",
    stroke: "#48525B",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3732 49.04C56.9741 47.622 59.0288 45.3783 60.2129 42.663C61.397 39.9476 61.6431 36.9153 60.9124 34.0445C60.1818 31.1737 58.5159 28.628 56.1777 26.8092C53.8395 24.9903 50.9622 24.0019 47.9999 24H44.6399C43.8327 20.878 42.3283 17.9795 40.2398 15.5226C38.1512 13.0657 35.5328 11.1142 32.5815 9.81493C29.6302 8.51562 26.4227 7.90227 23.2002 8.021C19.9777 8.13973 16.8241 8.98744 13.9764 10.5004C11.1287 12.0134 8.66099 14.1523 6.75889 16.7562C4.85678 19.3601 3.56973 22.3614 2.99451 25.5344C2.41928 28.7073 2.57084 31.9694 3.4378 35.0753C4.30475 38.1813 5.86454 41.0503 7.9999 43.4666",
    stroke: "#48525B",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6668 42.6667L32.0002 32L21.3335 42.6667",
    stroke: "#48525B",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadAlt);
export default __webpack_public_path__ + "static/media/upload-alt.c1e1bed83a1b5e11588760e1ad3d9fab.svg";
export { ForwardRef as ReactComponent };